export const UserSortFields = {
  Email: "email",
  Name: "name",
  Created: "created",
  Login: "login",
  Status: "status",
  Groups: "groups",
  Organisation: "organisation",
};
